import { useContext } from "react";
import { Asset } from "../data/Asset";
import { HttpMethods } from "../enums/HttpMethods";
import { NotificationTypes } from "../enums/NotificationTypes";
import { VillageDto } from "../dtos/VillageDto";
import VspPortalContext from "../store/VspPortalContext";
import { VspPortalActions } from "../store/VspPortalActions";
import { useVspPortalHttp } from "./useVspPortalHttp";


export const useVillagesHttp = ( ): {

    getVillages( domain: Asset ): Promise< VillageDto[] | null >

} => {

    const { state, dispatch } = useContext( VspPortalContext );
    const { fetchData, getHttpOptions } = useVspPortalHttp( );

    const getVillages = async ( asset: Asset ): Promise<VillageDto[] | null> => {

        if( state.villages[ asset ] !== undefined) {
        
            return Promise.resolve( state.villages[ asset ] );

        }

        
        const options = await getHttpOptions ( HttpMethods.Get, undefined );

        const query = `${process.env.REACT_APP_API_URL}/villages?assetCode=${ asset }`;
        
        const response = await fetchData( options, query  );

        if( response.statusCode === null ) {

            //TODO: display maintenance page

        }
        
        if ( response.response === null ) {

            dispatch({ type: VspPortalActions.SetNotificationType, payload: NotificationTypes.Error });
            dispatch({ type: VspPortalActions.SetNotificationText, payload: 'Error fetching villages' });

            return null;

        }

        const villageDtos: VillageDto[] = await response.response?.json( );
        dispatch({ type: VspPortalActions.SetVillages, payload: { asset, villageDtos }  });
        return villageDtos;

    };

    return { 
        
        getVillages

    };

};